import { CustomDefaultPlaceCategory } from './../commands/pagination.query.command';
import { isNullOrUndefined, isNumber } from 'util';
import { config } from '../../config/config';
import { HubPlaceAdditionalData } from '../models/hub/hub.google.place.data';
import { HubApiService } from './hub.api.service';
import { ShareService } from './share.service';
import { VisitorApiService } from './visitor.api.service';
import { VisitorDataCache } from '../stores/visitor.calendar.store';
import { HubPlace } from 'models/hub/hub.place';
import { PlaceType } from '../components/hub/place.category/customize.place.category.component';
import { localStorageKeys } from '../common/constants/local.storage.keys';

export class PlaceService {
  public static isAllCategoriesTurnedOff(placeCategory) {
    let isAllTurnedOff = true;
    for (let cate in placeCategory) {
      if (placeCategory[cate]) {
        isAllTurnedOff = false;
        break;
      }
    }
    return isAllTurnedOff;
  }

  public static getMatchedFacebookPlaceId(place, hubName, visitorApiService): Promise<any> {
    return new Promise((resolve, reject) => {
      if (place.socialName === 'google') {
        visitorApiService.getMatchedFBPlaceId(hubName, place.name, place.lat, place.lng).subscribe((data) => {
          resolve(data);
        });
      } else {
        reject('not Google place');
      }
    });
  }

  public static matchToFacebookPlace(place, hubName, visitorApiService: VisitorApiService): Promise<any> {
    return new Promise((resolve, reject) => {
      if (place.socialName === 'google') {
        visitorApiService.getMatchedFBPlace(hubName, place.name, place.lat, place.lng).subscribe((data) => {
          if (data && data.isMatched) {
            place.description = data.matchedPlace.description || data.matchedPlace.about;
            let id = ShareService.getFacebookPlaceId(data.matchedPlace.hostLink);
            // this.getFBPost(id);
            resolve({
              place,
              fbId: id,
            });
          } else {
            resolve('not matched');
          }
        });
      } else {
        reject('not Google place');
      }
    });
  }

  public static getGooglePlaceDetails(
    place,
    hubName,
    apiService: HubApiService | VisitorApiService,
    waitForUploading = false
  ): Promise<HubPlaceAdditionalData | null> {
    return new Promise((resolve, reject) => {
      if (place.socialName === 'google') {
        apiService.getGooglePlaceDetails(hubName, place.id, waitForUploading).subscribe((data: any) => {
          if (data) {
            let googlePlaceAdditionalData: HubPlaceAdditionalData = data;
            resolve(googlePlaceAdditionalData);
          } else {
            resolve(null);
          }
        });
      } else {
        // 'not Google place'
        reject(null);
      }
    });
  }

  public static checkIsAccommodation(place: HubPlace) {
    try {
      return VisitorDataCache.placeCategories['Accommodations'].any((x) =>
        place.categoryList.any((y) => x.toLowerCase() === y.toLowerCase())
      );
    } catch (e) {
      console.warn(`No place categories found in the cache`);
      console.warn(e);
      return false;
    }
  }

  public static getGooglePlaceReference(googleImgUrl: string) {
    if (googleImgUrl.includes('amazonaws')) return googleImgUrl;

    // https://lh3.googleusercontent.com/p/AF1QipPxB68d-2D5vOFIvPtTIIoWFisgA8vZaIN_uQJB=s1600-w240
    if (googleImgUrl.indexOf('/p/') >= 0 && googleImgUrl.indexOf('=s') >= 0) {
      return googleImgUrl.split('/p/')[1].split('=s')[0];
    }
    // https://maps.googleapis.com/maps/api/place/photo?maxwidth=240&photoreference=ATtYBwIYmydvl-nm5qGNVb6zDxp5pVBvPKYHB5rQsyyk9UZJnfSMYsYS-Iuo4FXhABE1Jx79Rv2o-XD1vwCscdRRT4ZaoZlfbzyCHxEFDB2j_DNmLtia_-PfxZq2zqepiuWn6xRz1T_5nV1jSMXHvRbQT_lmxRbe_UC0O9r1mYfM3zGJ8Sz2&key=AIzaSyAjcpYRF3EQc-LBw5w2_lpzKKeEBDiGLcM
    if (googleImgUrl.indexOf('photoreference=') >= 0 && googleImgUrl.indexOf('&key=') >= 0) {
      return googleImgUrl.split('photoreference=')[1].split('&key=')[0];
    }
    return googleImgUrl;
  }

  public static getGooglePlaceImageFullUrl(
    reference: string,
    appKey: string,
    isRealReference: boolean,
    isThumb = true
  ) {
    if (reference === 'null') {
      return '';
    }

    if (reference.startsWith('http')) {
      return reference;
    }

    if (isRealReference) {
      if (isThumb) {
        return config.google.placeRealPhotoThumb.replace('${short_reference}', reference);
      }
      return config.google.placeRealPhoto.replace('${short_reference}', reference);
    }
    if (isThumb) {
      return config.google.placePhotoThumb.replace('${photo_reference}', reference).replace('${appKey}', appKey);
    }
    return config.google.placePhoto.replace('${photo_reference}', reference).replace('${appKey}', appKey);
  }

  /**
   *  tourist_attraction, food, park => Tourist Attraction, Food, Park
   * */
  public static allToReadableCategory(category: string) {
    if (!category) return '';

    return category
      .split(',')
      .map((c) => {
        return PlaceService.toReadableCategory(c.trim());
      })
      .join(', ');
  }

  /**
   * tourist_attraction  => Tourist Attraction
   * b&b => B&B
   * arts_&_culture => Arts & Culture
   * */
  public static toReadableCategory(category: string) {
    return category
      .replaceAll('&', '_&_')
      .split('_')
      .map((x) => {
        return x.upperFirstLetter();
      })
      .join(' ')
      .replaceAll(' & ', '&');
  }

  /**
   *  Tourist Attraction => tourist_attraction
   * */
  public static toCategoryCode(category: string) {
    return category.toLowerCase().replaceAll(' ', '_');
  }

  public static getCustomDefaultCategoryFromURL(id, customDefaultPlaceCategory) {
    const category = this.getCustomDefaultPlaceCategoryById(id, customDefaultPlaceCategory);
    if (category) {
      let categoryList = [];
      PlaceService.getAllSubCategories(category, categoryList);
      return {
        category,
        categoryList,
        customDefaultPlaceCategory: {
          useDefault: false,
          customCategories: category.subCategories,
        },
      };
    } else {
      alert('The custom place category id is wrong, please check.');
      return null;
    }
  }

  public static getCustomDefaultPlaceCategoryById(
    id: string,
    customDefaultPlaceCategory: CustomDefaultPlaceCategory
  ): PlaceType {
    if (customDefaultPlaceCategory.useDefault) {
      return null;
    }

    let category: PlaceType = null;
    for (let customCategory of customDefaultPlaceCategory.customCategories) {
      category = this.getCustomDefaultCategoryWithId(id, customCategory as PlaceType);
      if (category) {
        break;
      }
    }

    console.log('custom category in URL', category);
    return category;
  }

  public static getAllSubCategories(item: PlaceType, categoryList: string[]) {
    if (item.subCategories && item.subCategories.length) {
      categoryList.push(...item.categoryList);
      for (let subCategory of item.subCategories) {
        this.getAllSubCategories(subCategory, categoryList);
      }
    } else {
      categoryList.push(...item.categoryList);
    }
  }

  public static getAllSubCategoriesWithEachLevelTitles(
    item: PlaceType,
    categoryList: string[],
    parentPath: string = ''
  ) {
    const currentPath = parentPath ? `${parentPath} > ${item.title}` : item.title;

    categoryList.push(currentPath);

    // to exclude this situation: "Accommodations > city 1 > City 1"
    // because each level path contains a same name sub-category
    if (currentPath.toLowerCase().split(' > ').last() !== PlaceService.toReadableCategory(item.title).toLowerCase()) {
      categoryList.push(`${currentPath} > ${PlaceService.toReadableCategory(item.title)}`);
    }

    // Recurse through subcategories
    if (item.subCategories && item.subCategories.length) {
      for (let subCategory of item.subCategories) {
        this.getAllSubCategoriesWithEachLevelTitles(subCategory, categoryList, currentPath);
      }
    }
  }

  private static getCustomDefaultCategoryWithId(id: string, category: PlaceType): PlaceType {
    if (
      category._id.toString().toLowerCase() === id.toLowerCase() ||
      category.title.toLowerCase() === id.toLowerCase()
    ) {
      return category;
    }

    for (let subCategory of category.subCategories) {
      const exist = this.getCustomDefaultCategoryWithId(id, subCategory);
      if (exist) return exist;
    }

    return null;
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/services/place.service.ts